module.exports = __webpack_public_path__ + "assets/docs/terms_of_use.pdf";